export const OPEN_LINKAGES_BY_ID = 'OPEN_LINKAGES_BY_ID'
